/* eslint-disable max-len */
import React from "react";

export const WarningIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path className="banner-icon-path" d="M12 2C17.514 2 22 6.486 22 12C22 17.514 17.514 22 12 22C6.486 22 2 17.514 2 12C2 6.486 6.486 2 12 2ZM12 0C5.373 0 0 5.373 0 12C0 18.627 5.373 24 12 24C18.627 24 24 18.627 24 12C24 5.373 18.627 0 12 0ZM10.69 7.526C10.591 6.719 11.218 6 12.038 6C12.809 6 13.415 6.676 13.318 7.451L12.561 13.504C12.526 13.787 12.285 14 12 14C11.715 14 11.474 13.787 11.438 13.504L10.69 7.526ZM12 18.25C11.31 18.25 10.75 17.69 10.75 17C10.75 16.31 11.31 15.75 12 15.75C12.69 15.75 13.25 16.31 13.25 17C13.25 17.69 12.69 18.25 12 18.25Z" fill="#042759" />
  </svg>
);
